// src/assets/documents/index.ts
// ドキュメントファイルのインポート

// 英語ドキュメント

// 日本語ドキュメント
import jaLegalNotice from "./ja/legal-notice.md";
import jaPrivacyPolicy from "./ja/privacy-policy.md";
import jaTermsOfService from "./ja/terms-of-service.md";
import jaKling from "./ja/models/kling.md";
import jaRunway from "./ja/models/runway.md";
import jaLuma from "./ja/models/luma.md";
import jaHailuo from "./ja/models/hailuo.md";
import jaHaiper from "./ja/models/haiper.md";
import jaPixverse from "./ja/models/pixverse.md";
import jaVidu from "./ja/models/vidu.md";
import jaBytedance from "./ja/models/bytedance.md";
import jaSync from "./ja/models/sync.md";
import jaGoogle from "./ja/models/google.md";
import jaWan from "./ja/models/wan.md";
import jaPika from "./ja/models/pika.md";
import jaTopazlabs from "./ja/models/topazlabs.md";
import jaDallE3 from "./ja/models/dalle3.md";
import jaFlux11Pro from "./ja/models/flux11pro.md";
import jaFlux11ProUltra from "./ja/models/flux11proultra.md";
import jaFlux11ProUltraJuno from "./ja/models/flux11proultrajuno.md";
import jaFluxJuno from "./ja/models/fluxjuno.md";
import jaSD35 from "./ja/models/sd35.md";
import jaSDUltra from "./ja/models/sdultra.md";
import jaImagen3 from "./ja/models/imagen3.md";
import jaImagen3Fast from "./ja/models/imagen3fast.md";
import jaIdeogramV2a from "./ja/models/ideogramv2a.md";
import jaIdeogramV2aTurbo from "./ja/models/ideogramv2aturbo.md";
import jaRecraftV3 from "./ja/models/recraftv3.md";
import jaLuminaV2 from "./ja/models/luminav2.md";
import jaGeminiFlashEdit from "./ja/models/geminiflashedit.md";
import jaKolorsVTO from "./ja/models/kolorsvto.md";
import jaICLightV2 from "./ja/models/iclightv2.md";
import jaFluxJuggernautBase from "./ja/models/fluxjuggernautbase.md";
import jaFluxJuggernautLightning from "./ja/models/fluxjuggernautlightning.md";
import jaFluxJuggernautPro from "./ja/models/fluxjuggernautpro.md";
import jaFluxJuggernautJuno from "./ja/models/fluxjuggernautjuno.md";
import jaFlux1Schnell from "./ja/models/flux1schnell.md";
import jaFlux1RealismLoRA from "./ja/models/flux1realismlora.md";
import jaFlux1ProCanny from "./ja/models/flux1procanny.md";
import jaFlux1ProCannyJuno from "./ja/models/flux1procannyjuno.md";
import jaFlux1ProDepth from "./ja/models/flux1prodepth.md";
import jaFlux1ProDepthJuno from "./ja/models/flux1prodepthjuno.md";
import jaFlux1ProFill from "./ja/models/flux1profill.md";
import jaFlux1ProFillJuno from "./ja/models/flux1profilljuno.md";
import jaFlux1Dev from "./ja/models/flux1dev.md";
import jaFlux1DevFill from "./ja/models/flux1devfill.md";
import jaFlux11ProRedux from "./ja/models/flux11proredux.md";
import jaFlux1DevRedux from "./ja/models/flux1devredux.md";
import jaFlux1SchnellRedux from "./ja/models/flux1schnellredux.md";
import jaFlux11ProUltraRedux from "./ja/models/flux11proultraredux.md";
import jaFlux1DevCannyLoRA from "./ja/models/flux1devcannylora.md";
import jaFlux1DevDepthLoRA from "./ja/models/flux1devdepthlora.md";
import jaFluxPuLID from "./ja/models/fluxpulid.md";
import jaIdeogramV2Edit from "./ja/models/ideogramv2edit.md";
import jaIdeogramV2TurboEdit from "./ja/models/ideogramv2turboedit.md";
import jaAuraSR from "./ja/models/aurasr.md";
import jaClarityUpscaler from "./ja/models/clarityupscaler.md";
import jaCreativeUpscaler from "./ja/models/creativeupscaler.md";
import jaRecraftClarityUpscaler from "./ja/models/recraftclarityupscaler.md";
import jaMinimaxImage from "./ja/models/minimax.md";
import jaBriaBackgroundReplace from "./ja/models/briabackgroundreplace.md";
import jaBriaProductShot from "./ja/models/briaproductshot.md";
import jaSD3 from "./ja/models/sd3.md";
import jaFlux1ProJuno from "./ja/models/flux1projuno.md";
import jaRealesrgan from "./ja/models/realesrgan.md";
import jaRecraftCreativeUpscaler from "./ja/models/recraftcreativeupscaler.md";
import enLegalNotice from "./en/legal-notice.md";
import enPrivacyPolicy from "./en/privacy-policy.md";
import enTermsOfService from "./en/terms-of-service.md";

// エクスポート
export const Documents = {
  en: {
    legalNotice: enLegalNotice,
    privacyPolicy: enPrivacyPolicy,
    termsOfService: enTermsOfService,
    models: {},
  },
  ja: {
    legalNotice: jaLegalNotice,
    privacyPolicy: jaPrivacyPolicy,
    termsOfService: jaTermsOfService,
    models: {
      // 画像モデル
      dalle3: jaDallE3,
      flux11pro: jaFlux11Pro,
      flux11proultra: jaFlux11ProUltra,
      flux11proultrajuno: jaFlux11ProUltraJuno,
      fluxjuno: jaFluxJuno,
      sd35: jaSD35,
      sdultra: jaSDUltra,
      imagen3: jaImagen3,
      imagen3fast: jaImagen3Fast,
      ideogramv2a: jaIdeogramV2a,
      ideogramv2aturbo: jaIdeogramV2aTurbo,
      recraftv3: jaRecraftV3,
      luminav2: jaLuminaV2,
      geminiflashedit: jaGeminiFlashEdit,
      kolorsvto: jaKolorsVTO,
      iclightv2: jaICLightV2,
      fluxjuggernautbase: jaFluxJuggernautBase,
      fluxjuggernautlightning: jaFluxJuggernautLightning,
      fluxjuggernautpro: jaFluxJuggernautPro,
      fluxjuggernautjuno: jaFluxJuggernautJuno,
      flux1schnell: jaFlux1Schnell,
      flux1realismlora: jaFlux1RealismLoRA,
      flux1procanny: jaFlux1ProCanny,
      flux1procannyjuno: jaFlux1ProCannyJuno,
      flux1prodepth: jaFlux1ProDepth,
      flux1prodepthjuno: jaFlux1ProDepthJuno,
      flux1profill: jaFlux1ProFill,
      flux1profilljuno: jaFlux1ProFillJuno,
      flux1dev: jaFlux1Dev,
      flux1devfill: jaFlux1DevFill,
      flux11proredux: jaFlux11ProRedux,
      flux1devredux: jaFlux1DevRedux,
      flux1schnellredux: jaFlux1SchnellRedux,
      flux11proultraredux: jaFlux11ProUltraRedux,
      flux1devcannylora: jaFlux1DevCannyLoRA,
      flux1devdepthlora: jaFlux1DevDepthLoRA,
      fluxpulid: jaFluxPuLID,
      ideogramv2edit: jaIdeogramV2Edit,
      ideogramv2turboedit: jaIdeogramV2TurboEdit,
      aurasr: jaAuraSR,
      clarityupscaler: jaClarityUpscaler,
      creativeupscaler: jaCreativeUpscaler,
      recraftclarityupscaler: jaRecraftClarityUpscaler,
      minimax: jaMinimaxImage,
      briabackgroundreplace: jaBriaBackgroundReplace,
      briaproductshot: jaBriaProductShot,
      sd3: jaSD3,
      flux1projuno: jaFlux1ProJuno,
      realesrgan: jaRealesrgan,
      recraftcreativeupscaler: jaRecraftCreativeUpscaler,
      // 動画モデル
      kling: jaKling,
      runway: jaRunway,
      luma: jaLuma,
      hailuo: jaHailuo,
      haiper: jaHaiper,
      pixverse: jaPixverse,
      vidu: jaVidu,
      bytedance: jaBytedance,
      sync: jaSync,
      google: jaGoogle,
      wan: jaWan,
      pika: jaPika,
      topazlabs: jaTopazlabs,
    },
  },
};

// 個別エクスポート
export {
  jaLegalNotice,
  jaPrivacyPolicy,
  jaTermsOfService,
  jaDallE3,
  jaFlux11Pro,
  jaFlux11ProUltra,
  jaFlux11ProUltraJuno,
  jaFluxJuno,
  jaSD35,
  jaSDUltra,
  jaImagen3,
  jaImagen3Fast,
  jaIdeogramV2a,
  jaIdeogramV2aTurbo,
  jaRecraftV3,
  jaLuminaV2,
  jaGeminiFlashEdit,
  jaKolorsVTO,
  jaICLightV2,
  jaFluxJuggernautBase,
  jaFluxJuggernautLightning,
  jaFluxJuggernautPro,
  jaFluxJuggernautJuno,
  jaFlux1Schnell,
  jaFlux1RealismLoRA,
  jaFlux1ProCanny,
  jaFlux1ProCannyJuno,
  jaFlux1ProDepth,
  jaFlux1ProDepthJuno,
  jaFlux1ProFill,
  jaFlux1ProFillJuno,
  jaFlux1Dev,
  jaFlux1DevFill,
  jaFlux11ProRedux,
  jaFlux1DevRedux,
  jaFlux1SchnellRedux,
  jaFlux11ProUltraRedux,
  jaFlux1DevCannyLoRA,
  jaFlux1DevDepthLoRA,
  jaFluxPuLID,
  jaIdeogramV2Edit,
  jaIdeogramV2TurboEdit,
  jaAuraSR,
  jaClarityUpscaler,
  jaCreativeUpscaler,
  jaRecraftClarityUpscaler,
  jaMinimaxImage,
  jaBriaBackgroundReplace,
  jaBriaProductShot,
  jaSD3,
  jaFlux1ProJuno,
  jaRealesrgan,
  jaRecraftCreativeUpscaler,
  // 動画モデル
  jaKling,
  jaRunway,
  jaLuma,
  jaHailuo,
  jaHaiper,
  jaPixverse,
  jaVidu,
  jaBytedance,
  jaSync,
  jaGoogle,
  jaWan,
  jaPika,
  jaTopazlabs,
};
